import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useAuth } from "@/hooks/useAuth";
import { Workspace, Organization, WorkspaceMember } from "@/types/workspace";

/**
 * TEMPORARY STABLE IMPLEMENTATION
 * --------------------------------
 * - Supabase REMOVED
 * - verifySession REMOVED
 * - JWT-based auth assumed
 * - Backend API integration ready
 */

export const useWorkspaces = () => {
  const { user } = useAuth();

  const workspacesQuery = useQuery<(Workspace & { organization?: Organization })[]>({
    queryKey: ["workspaces", user?.id],
    enabled: !!user,
    queryFn: async () => {
      // 🔐 JWT already attached via Axios interceptor
      // TODO: Replace with real API later → GET /api/workspaces

      return [
        {
          id: "demo-workspace",
          name: "Demo Workspace",
          is_default: true,
          created_at: new Date().toISOString(),
          organization: {
            id: "demo-org",
            name: "BillPortal",
          } as Organization,
        } as Workspace & { organization: Organization },
      ];
    },
  });

  const defaultWorkspaceQuery = useQuery<string>({
    queryKey: ["default-workspace", user?.id],
    enabled: !!user,
    queryFn: async () => {
      // Matches JWT: workspace_id = "demo-workspace"
      return "demo-workspace";
    },
  });

  return {
    workspaces: workspacesQuery.data || [],
    defaultWorkspaceId: defaultWorkspaceQuery.data,
    isLoading: workspacesQuery.isLoading || defaultWorkspaceQuery.isLoading,
    error: workspacesQuery.error || defaultWorkspaceQuery.error,
  };
};

/**
 * Workspace Members (STUB)
 * -----------------------
 * Replace later with:
 * GET /api/workspaces/{id}/members
 */
export const useWorkspaceMembers = (_workspaceId: string) => {
  return {
    members: [] as WorkspaceMember[],
    isLoading: false,
    error: null,
    inviteMember: () => {},
    isInviting: false,
  };
};